/* eslint-disable react/jsx-no-target-blank */
import React, { memo, useState } from 'react'
import PropTypes from 'prop-types'

// import { ReactComponent as IconFile } from '../assets/images/file.svg'
import { ReactComponent as IconFailure } from '../assets/images/failure-download-file.svg'
import { ReactComponent as IconDownload } from '../assets/images/icon-download.svg'
import { ReactComponent as IconLoader } from '../assets/images/loader-download-file.svg'
import api from '../axios/api';
import { useEffect } from 'react';

/**
 * id           number
 * blockType    number
 * fileURL      string
 * fileName      string
 * fileSize     number
 * fileType     string
 * typeMessage  string
 */

const checkTypeFile = (fileType) => {
  if (fileType.includes('image')) return 'image'

  return 'file'
}

const sizeFile = (size) => {
  if (size < 1024) return size + ' B'
  else if (1024 > (size / 1024)) return parseFloat((size / 1024)).toFixed(1) + ' KB'
  else if (1024 > (size / 1024) / 1024) return parseFloat((size / 1024) / 1024).toFixed(1) + ' MB'
  else if (1024 > ((size / 1024) / 1024) / 1024) return parseFloat(((size / 1024) / 1024) / 1024).toFixed(1) + ' GB'

  return 'err'
}

const FileContainer = memo(({ showImage, typeMessage, fileType, fileURL, fileName, fileSize, paramsApp, status, timeMessage }) => {
  const typeFile = checkTypeFile(fileType)

  if (!typeFile) return <></>
  return (
    <div className={`files-container ${typeMessage} ${typeFile}`}>
      {typeFile === 'image' && <Image showImage={showImage} urlImage={fileURL} time={timeMessage}/>}
      {typeFile === 'file' && (
        <File
          typeFile={typeFile}
          typeMessage={typeMessage}
          fileURL={fileURL}
          fileName={fileName}
          fileSize={fileSize}
          paramsApp={paramsApp}
          status={status}
          time={timeMessage}
        />
      )}
    </div>
  )
})
const Image = ({ showImage, urlImage, time }) => {
  return (
    <div className="image-container" onClick={() => showImage(urlImage)}>
      <img src={urlImage} alt="" />
      <span className='image-time'>{time}</span>
    </div>
  )
}

const File = ({ typeMessage, fileURL, fileName, fileSize, paramsApp, status, time }) => {
  const [statusFile, setStatusLoading] = useState('loading')

  useEffect(() => {
    setStatusLoading(status)
  }, [status])

  const downloadFile = () => {
    if (paramsApp.appVersion) {
      if (paramsApp.platform === 'android') {
        const link = document.createElement('a');
        link.href = fileURL;
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)

      } else {
        window.location.assign('#download=' + fileURL)

        setTimeout(() => window.location.hash = '', 100)
      }

      return
    }

    if (statusFile === 'loading') return

    setStatusLoading('loading')
    api.downloadFile(fileURL)
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName); //or any other extension
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)
      })
      .catch(error => {
        console.error(error);
      })
      .finally(() => {
        setStatusLoading('success')
      })
  }
  return (
    <div className={`file-container ${typeMessage} `}>
      <button
        className={`button_download-file ${statusFile !== 'success' && 'not-active'}`}
        onClick={e => statusFile === 'success' ? downloadFile(e) : () => {}}
      >
        {statusFile === 'loading' && <IconLoader />}
        {statusFile === 'success' && <IconDownload />}
        {statusFile === 'failure' && <IconFailure />}
      </button>
      <div className="file-container__block">
        <span className="name-file">{fileName}</span>
        <span className="size-file">{sizeFile(fileSize)}</span>
        <span className='file-time'>{time}</span>
      </div>
    </div>
  )
}

FileContainer.propTypes = {
  showImage: PropTypes.func,
  typeMessage: PropTypes.string,
  fileType: PropTypes.string,
  fileURL: PropTypes.string,
  fileName: PropTypes.string,
  fileSize: PropTypes.number,
  paramsApp: PropTypes.object,
  status: PropTypes.string
}
Image.propTypes = {
  showImage: PropTypes.func,
  urlImage: PropTypes.string,
}
File.propTypes = {
  typeMessage: PropTypes.string,
  fileURL: PropTypes.string,
  fileName: PropTypes.string,
  fileSize: PropTypes.number,
  paramsApp: PropTypes.object,
  status: PropTypes.string
}


FileContainer.displayName = 'FileContainer';

export default FileContainer